import SEOPageTemplate from '../components/SEOPageTemplate';

const ChauffeurPortland = () => (
  <SEOPageTemplate
    city="Portland"
    state="ME"
    route="/chauffeur-portland-me"
    imageSrc="/portland-me-limo.jpg"
    introduction="In Portland, Maine's vibrant coastal city, TiLimousine provides a transportation service that captures the essence of New England charm while meeting modern business needs. Our chauffeurs are intimately familiar with Portland's unique character, from the historic Old Port to the bustling Arts District. Whether you're visiting for a business meeting in the Financial District, exploring the waterfront, or attending an event at the Convention Center, our service ensures your journey through Portland is as delightful as the city itself."
    testimonial={{
      quote: "As a seafood industry executive, I frequently host clients visiting from around the world. TiLimousine's chauffeurs understand the importance of showcasing Portland's charm while maintaining professional service. Their knowledge of the city's best restaurants and waterfront locations has been invaluable for our business.",
      author: "Thomas B.",
      role: "CEO, Portland Seafood Exports"
    }}
    services={[
      'Luxury chauffeur service for airport transfers and FBO pickup',
      'Executive car service and black car service for business travel',
      'Hourly chauffeur hire and as-directed black car service',
      'Private driver service for events, weddings, and VIPs',
      'Long-distance city-to-city rides: Portland ⇄ Boston, Portland ⇄ Bangor',
      'Professional chauffeur company for meetings and corporate events',
      'Livery service and luxury livery transportation',
      'Town car service and car and driver rental',
      'Book a chauffeur in Portland',
      'Best chauffeur in Maine',
      'Chauffeured transportation for VIPs',
      'Luxury car with driver',
      'Business travel car service',
      'Limo vs black car service Portland',
      'Best executive car service in Portland',
      'FBO pickup with luxury car',
      'Chauffeur for meetings and corporate events'
    ]}
    airports={[
      'Portland International Jetport (PWM)',
      'Signature Flight Support',
      'Atlantic Aviation',
      'Logan International Airport (BOS)',
      'Bangor International Airport (BGR)',
      'Teterboro Airport (TEB)',
      'JFK',
      'LGA'
    ]}
    neighborhoods={[
      'Old Port',
      'Arts District',
      'Financial District',
      'West End',
      'East End',
      'Waterfront',
      'Bayside',
      'Deering Center',
      'Munjoy Hill',
      'South Portland',
      'Falmouth',
      'Greater Portland Area'
    ]}
  />
);

export default ChauffeurPortland; 